import { AvailableField } from '../ZohoEmployeeFieldsSetup/types';

export function getAvailableEmployeeStatuses(availableFields: AvailableField[]): string[] {
  const employeeTypeOptions =
    availableFields.find((field) => field.labelname === 'Employeestatus')?.Options || [];

  return Object.values(employeeTypeOptions) as string[];
}
